<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 9C50.9117 9 63 21.0883 63 36C63 50.9117 50.9117 63 36 63C21.0883 63 9 50.9117 9 36C9 21.0883 21.0883 9 36 9"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.5 21V37.5H24"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1448_172902"
        x1="9"
        y1="63"
        x2="63"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1448_172902"
        x1="24"
        y1="37.5"
        x2="40.1733"
        y2="24.2673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="0.651042" stop-color="currentColor" />
      </linearGradient>
    </defs>
  </svg>
</template>
